var _g, _rect, _g2, _rect2, _rect3, _rect4, _path, _path2, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _path3, _path4, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEmptyState(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 345,
    height: 159,
    viewBox: "0 0 345 159",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1guwn251ea)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.632,
    y: 116.126,
    width: 166.781,
    height: 44.207,
    rx: 2.138,
    transform: "rotate(-15.223 171.632 116.126)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#43B02A",
    d: "m171.632 116.126 2.063-.561 11.565 42.498-2.063.562z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 190.981,
    cy: 126.151,
    r: 5.346,
    transform: "rotate(-15.223 190.981 126.151)",
    fill: "#43B02A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M192.487 124.236a.39.39 0 0 1 .161.528l-1.521 2.844a.394.394 0 0 1-.539.155l-1.439-.824a.391.391 0 0 1 .388-.678l1.091.624 1.331-2.489a.39.39 0 0 1 .528-.16z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.629,
    y: 119.695,
    width: 53.249,
    height: 6.028,
    rx: 2.009,
    transform: "rotate(-15.223 203.629 119.695)",
    fill: "#B6BEC5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 206.862,
    y: 131.578,
    width: 121.569,
    height: 5.024,
    rx: 1.005,
    transform: "rotate(-15.223 206.862 131.578)",
    fill: "#B6BEC5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 208.743,
    y: 138.488,
    width: 121.569,
    height: 5.024,
    rx: 1.005,
    transform: "rotate(-15.223 208.743 138.488)",
    fill: "#B6BEC5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 171.894,
    y: 116.276,
    width: 166.353,
    height: 43.779,
    rx: 1.925,
    transform: "rotate(-15.223 171.894 116.276)",
    stroke: "#EAECF0",
    strokeWidth: 0.428
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bmxsi0mxbb)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.832,
    y: 43.993,
    width: 88.476,
    height: 23.451,
    rx: 1.134,
    transform: "rotate(-15 .832 43.993)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFC021",
    d: "m.832 43.993 1.095-.293 6.047 22.569-1.095.293zM11.81 52.091a2.835 2.835 0 1 0-1.468-5.477 2.835 2.835 0 0 0 1.468 5.477zm-1.302-3.761a.283.283 0 1 1 .548-.147l.367 1.37a.283.283 0 1 1-.548.146l-.367-1.37zm.788 1.844a.283.283 0 1 1 .147.547.283.283 0 0 1-.147-.547z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 17.799,
    y: 45.952,
    width: 28.248,
    height: 3.198,
    rx: 1.066,
    transform: "rotate(-15 17.799 45.952)",
    fill: "#B6BEC5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 19.489,
    y: 52.263,
    width: 64.492,
    height: 2.665,
    rx: 0.533,
    transform: "rotate(-15 19.49 52.263)",
    fill: "#B6BEC5"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 20.473,
    y: 55.933,
    width: 64.492,
    height: 2.665,
    rx: 0.533,
    transform: "rotate(-15 20.473 55.933)",
    fill: "#B6BEC5"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.971,
    y: 44.073,
    width: 88.249,
    height: 23.225,
    rx: 1.021,
    transform: "rotate(-15 .97 44.073)",
    stroke: "#EAECF0",
    strokeWidth: 0.227
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 42.62,
    y: 79.527,
    width: 110.006,
    height: 45.296,
    rx: 1.238,
    transform: "rotate(17.333 42.62 79.527)",
    fill: "#fff"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 45.2,
    y: 91.536,
    width: 23.906,
    height: 23.906,
    rx: 11.953,
    transform: "rotate(17.333 45.2 91.536)",
    fill: "#465DD8"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M56.1 102.108a1.613 1.613 0 0 0-1.052-2.007 1.597 1.597 0 0 0-2.006 1.052 1.597 1.597 0 0 0-2.006 1.052l-.12.382a.396.396 0 0 0 .264.502l5.35 1.67a.412.412 0 0 0 .502-.263l.12-.382a1.612 1.612 0 0 0-1.052-2.006zm-1.708.096a.579.579 0 0 1-.394-.753.593.593 0 0 1 .752-.394c.31.097.491.442.394.752a.593.593 0 0 1-.752.395zm.058 4.265-2.43 1.653-.645-1.04a.623.623 0 0 0-.834-.182.624.624 0 0 0-.182.835l.98 1.564a.675.675 0 0 0 .369.246c.143.045.316-.006.449-.096l2.937-2.019a.553.553 0 0 0 .15-.818c-.147-.282-.52-.346-.794-.143z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "m58.8 104.209-2.625 8.408a1.201 1.201 0 0 1-1.504.789l-6.88-2.147a1.186 1.186 0 0 1-.789-1.505l2.624-8.408a1.2 1.2 0 0 1 1.505-.789l1.911.596a1.597 1.597 0 0 0-2.006 1.052l-.12.382a.396.396 0 0 0 .264.502l5.35 1.67a.412.412 0 0 0 .502-.263l.12-.382a1.612 1.612 0 0 0-1.052-2.006l1.911.596c.621.194.983.883.789 1.505z",
    fill: "#fff"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 73.294,
    y: 102.467,
    width: 33.289,
    height: 4.205,
    rx: 0.701,
    transform: "rotate(17.333 73.294 102.467)",
    fill: "#B6BEC5"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 70.3,
    y: 112.06,
    width: 63.775,
    height: 2.453,
    rx: 0.701,
    transform: "rotate(17.333 70.3 112.06)",
    fill: "#B6BEC5"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 69.325,
    y: 115.184,
    width: 63.775,
    height: 2.453,
    rx: 0.701,
    transform: "rotate(17.333 69.325 115.184)",
    fill: "#B6BEC5"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 99.461,
    y: 134.625,
    width: 33.289,
    height: 2.803,
    rx: 0.701,
    transform: "rotate(17.333 99.461 134.625)",
    fill: "#6B7DE0"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 42.62,
    y: 79.527,
    width: 110.006,
    height: 45.296,
    rx: 1.238,
    transform: "rotate(17.333 42.62 79.527)",
    stroke: "#EAECF0",
    strokeWidth: 0.257
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 230.027,
    y: 59.951,
    width: 76.287,
    height: 31.412,
    rx: 0.858,
    transform: "rotate(-32.281 230.027 59.95)",
    fill: "#fff"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 237.53,
    y: 63.983,
    width: 16.579,
    height: 16.578,
    rx: 8.289,
    transform: "rotate(-32.281 237.53 63.983)",
    fill: "#465DD8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M250.805 62.521a.535.535 0 0 1 .417.66l-.692 3.065a.535.535 0 0 1-.66.417l-1.379-.299-.481 2.131a.536.536 0 0 1-.661.417.535.535 0 0 1-.417-.66l.605-2.682a.536.536 0 0 1 .661-.417l1.379.3.567-2.515a.536.536 0 0 1 .661-.417z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M243.692 65.495a.57.57 0 0 1 .766.173l3.115 4.93c.083.132.251.17.383.086l5.869-3.707a.571.571 0 0 1 .766.173.56.56 0 0 1-.173.766l-5.869 3.707a1.37 1.37 0 0 1-1.915-.432l-3.115-4.93a.56.56 0 0 1 .173-.766z",
    fill: "#fff"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 255.928,
    y: 54.055,
    width: 23.085,
    height: 2.916,
    rx: 0.486,
    transform: "rotate(-32.281 255.928 54.055)",
    fill: "#B6BEC5"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 259.65,
    y: 59.946,
    width: 44.227,
    height: 1.701,
    rx: 0.486,
    transform: "rotate(-32.281 259.65 59.946)",
    fill: "#B6BEC5"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 260.862,
    y: 61.865,
    width: 44.227,
    height: 1.701,
    rx: 0.486,
    transform: "rotate(-32.281 260.862 61.865)",
    fill: "#B6BEC5"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.5,
    x: 284.673,
    y: 54.683,
    width: 23.085,
    height: 1.944,
    rx: 0.486,
    transform: "rotate(-32.281 284.673 54.683)",
    fill: "#6B7DE0"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 230.027,
    y: 59.951,
    width: 76.287,
    height: 31.412,
    rx: 0.858,
    transform: "rotate(-32.281 230.027 59.95)",
    stroke: "#EAECF0",
    strokeWidth: 0.178
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 107.646,
    y: 1.132,
    width: 118.676,
    height: 84.304,
    rx: 1.131,
    transform: "rotate(7.659 107.646 1.132)",
    fill: "#fff"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 112.599,
    y: 5.707,
    width: 30.409,
    height: 3.841,
    rx: 0.64,
    transform: "rotate(7.659 112.599 5.707)",
    fill: "#B6BEC5"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 111.052,
    y: 17.211,
    width: 30.409,
    height: 1.974,
    rx: 0.64,
    transform: "rotate(7.659 111.052 17.21)",
    fill: "#B6BEC5"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 110.42,
    y: 21.906,
    width: 98.164,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 110.42 21.906)",
    fill: "#B6BEC5"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 109.754,
    y: 26.865,
    width: 98.164,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 109.754 26.865)",
    fill: "#B6BEC5"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 109.087,
    y: 31.824,
    width: 58.256,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 109.087 31.824)",
    fill: "#B6BEC5"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 107.753,
    y: 41.742,
    width: 30.409,
    height: 1.974,
    rx: 0.64,
    transform: "rotate(7.659 107.753 41.742)",
    fill: "#B6BEC5"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 107.122,
    y: 46.438,
    width: 98.164,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 107.122 46.438)",
    fill: "#B6BEC5"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 105.937,
    y: 55.244,
    width: 2.009,
    height: 2.009,
    rx: 0.64,
    transform: "rotate(7.659 105.937 55.244)",
    fill: "#B6BEC5"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 110.931,
    y: 55.8,
    width: 92.802,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 110.931 55.8)",
    fill: "#B6BEC5"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 105.271,
    y: 60.203,
    width: 2.009,
    height: 2.009,
    rx: 0.64,
    transform: "rotate(7.659 105.271 60.203)",
    fill: "#B6BEC5"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 110.265,
    y: 60.759,
    width: 92.802,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 110.265 60.759)",
    fill: "#B6BEC5"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 104.604,
    y: 65.162,
    width: 2.009,
    height: 2.009,
    rx: 0.64,
    transform: "rotate(7.659 104.604 65.162)",
    fill: "#B6BEC5"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 109.598,
    y: 65.717,
    width: 92.802,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 109.598 65.717)",
    fill: "#B6BEC5"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.4,
    x: 103.45,
    y: 73.741,
    width: 58.256,
    height: 2.241,
    rx: 0.64,
    transform: "rotate(7.659 103.45 73.741)",
    fill: "#B6BEC5"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 107.646,
    y: 1.132,
    width: 118.676,
    height: 84.304,
    rx: 1.131,
    transform: "rotate(7.659 107.646 1.132)",
    stroke: "#EAECF0",
    strokeWidth: 0.235
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "1guwn251ea"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 171.632,
    y: 116.126,
    width: 166.781,
    height: 44.207,
    rx: 2.138,
    transform: "rotate(-15.223 171.632 116.126)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bmxsi0mxbb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.832,
    y: 43.993,
    width: 88.476,
    height: 23.451,
    rx: 1.134,
    transform: "rotate(-15 .832 43.993)",
    fill: "#fff"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyState);
export default __webpack_public_path__ + "static/media/Empty_state.99083771.svg";
export { ForwardRef as ReactComponent };